import type { RouteRecordRaw } from 'vue-router';
import { jobIsAvailableRouteGuard } from './routeGuards';

export const JOB_UNAVAILABLE = 'job-unavailable';
export const STUDIO_ACCESS_CODE = 'studio-access-code';
export const SUBJECT_SEARCH = 'job-subject-form';
export const SUBJECTS_GALLERY = 'job-subjectsgallery';
export const CONFIRM_CART = 'confirm-cart';
export const DIGITAL_DOWNLOAD = 'digital-download';
export const AUTO_STUDIO_ACCESS_CODE = 'auto-studio-access-code';

export const routes: RouteRecordRaw[] = [
  {
    path: '',
    alias: '/:studioSlug',
    name: STUDIO_ACCESS_CODE,
    component: () => import('./pages/Entry/JobSearch/JobSearchPage.vue'),
  },
  {
    path: '/:studioSlug',
    children: [
      {
        path: 'code/:code',
        name: AUTO_STUDIO_ACCESS_CODE,
        component: () => import('./pages/Entry/JobSearch/JobSearchPage.vue'),
      },
      {
        path: ':jobId/unavailable',
        name: JOB_UNAVAILABLE,
        component: () => import('./pages/UnavailablePage.vue'),
      },
    ],
  },
  {
    path: ':jobId',
    children: [
      {
        path: 'search',
        alias: '/:studioSlug/:jobId',
        name: SUBJECT_SEARCH,
        component: () => import('./pages/Entry/SubjectSearch/SubjectSearchPage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        path: 'select-subject',
        component: () => import('./pages/SubjectsGallery/SubjectsGalleryPage.vue'),
        name: SUBJECTS_GALLERY,
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        name: CONFIRM_CART,
        path: 'confirmCart',
        component: () => import('./pages/ConfirmCartPage.vue'),
      },
    ],
  },
];

export const digitalRoute: RouteRecordRaw[] = [
  {
    name: DIGITAL_DOWNLOAD,
    //I like having job id but may need to consider forwarding links
    //path: ':jobId/download/:linkId',
    path: 'download/:linkId',
    component: () => import('./pages/DigitalDownloadPage.vue'),
  },
];
